// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settings-popup {\n  position: fixed;\n  top: 0;\n  right: -300px;\n  width: 300px;\n  height: 100%;\n  background-color: white;\n  z-index: 1000;\n  transition: right 0.3s ease;\n}\n\n.settings-popup.open {\n  right: 0;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
